import DepositInstantAccessSettings from "@/models/Products/ProductSettings/DefaultSettings/InstantAccess/DepositInstantAccessSettings";

export default class AccountDepositInstantAccessSettings extends DepositInstantAccessSettings {
    overridden: boolean = false;
}